import React from "react";

export const Admindrawer = () => {
  return <div>admin drawer</div>;
};
